import styled from 'styled-components'

export const StyledContainer = styled.div`
  background: ${({ theme }) => theme.colors.bgBase};
  min-height: 100vh;
`

export const StyledMainWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  ${({ theme }) => theme.media.sm`
    gap: 0;
  `}
`

export const StyledFormsWrapper = styled.div`
  ${({ theme }) => theme.media.sm`
    width: 100%;
  `}
`
